module.exports = __webpack_public_path__ + "static/media/gallery-7.b0353019.jpg";